import {
  SaveMetaPhoto_Input,
  useSaveClientReportPhotoCardMutation
} from 'generated/graphql';
import React from 'react';

export function useSaveClientReportPhoto() {
  const [
    fnMutate,
    tuple
  ] = useSaveClientReportPhotoCardMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SaveMetaPhoto_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
